import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

export type PillProps = ComponentProps<"div">

/**
 * A pure styled component implementing the BeeKit pill.
 * @params props All div props
 */
export function Pill(props: PillProps) {
  const { className, ...restProps } = props
  return (
    <div
      className={twMerge(
        "flex w-fit items-center justify-end gap-2 rounded-full bg-gray-100 px-2 py-1 text-sm whitespace-nowrap",
        className
      )}
      {...restProps}
    />
  )
}
